export default __webpack_public_path__ + "static/media/menu.1f4f8199.svg";